import api from './api';
import { Company, CreateCompanyRequest, UpdateCompanyRequest } from '../types/company';

export const companyService = {
  // Get all companies
  getCompanies: async (): Promise<Company[]> => {
    const response = await api.get('/companies');
    return response.data;
  },

  // Get single company by ID
  getCompany: async (id: number): Promise<Company> => {
    const response = await api.get(`/companies/${id}`);
    return response.data;
  },

  // Get active company (for quotations)
  getActiveCompany: async (): Promise<Company> => {
    const response = await api.get('/companies/active');
    return response.data;
  },

  // Create new company
  createCompany: async (data: CreateCompanyRequest): Promise<{ message: string; company: Company }> => {
    const response = await api.post('/companies', data);
    return response.data;
  },

  // Update company
  updateCompany: async (id: number, data: UpdateCompanyRequest): Promise<{ message: string; company: Company }> => {
    const response = await api.put(`/companies/${id}`, data);
    return response.data;
  },

  // Delete company (soft delete)
  deleteCompany: async (id: number): Promise<{ message: string }> => {
    const response = await api.delete(`/companies/${id}`);
    return response.data;
  }
};